export interface HistoryDetailResponse {
    tech_topic: string;
    target_lang: string;
    input: string;
    source_lang: string;
    keywords: {
        original: string[];
        percentage: number;
        translation: string;
    }[],
    content: {
        src_text: string;
        graph_index: number;
        translated_text: string;
    }[],
    current_step: string;
}

export interface ApiGetHistoryDetailResponse {
    task_id: string;
    title: string;
    is_read: boolean;
    updated_at: string;
    task_type: string;
    async_status: string;
    type: string;
    detail: Partial<HistoryDetailResponse>;
}

export const GetHistoryDetail = Symbol('GetHistoryDetail');

export interface GetHistoryDetail {
    getHistoryDetail(taskId: string): Promise<ApiGetHistoryDetailResponse>;
}
